import _extends from "@babel/runtime/helpers/esm/extends";
import { Event } from '@deezer/event-target';

// The enum of event types for this “namespace” (do not export, see below)
var Events = /*#__PURE__*/function (Events) {
  Events["USER_CHANGED"] = "LegacyUserChangedEvent";
  Events["USER_ERROR"] = "UserErrorEvent";
  return Events;
}(Events || {}); // This is necessary so we can “extends” the enum later
// This will be the enum to use accross the application
export const LegacyUserEvents = _extends({}, Events);

// This is the mapping between LegacyUserEvents (enum) and LegacyUserEvents (class)

export default class LegacyUserEvent extends Event {}